'use strict';
const qs  = s => document.querySelector(s);
const qsa = s => [...document.querySelectorAll(s)];

/* ── CURSOR ── */
(()=>{
  const dot=qs('#cur-dot'), ring=qs('#cur-ring');
  if(!dot||!ring) return;
  // Only activate on non-touch devices
  if(window.matchMedia('(pointer:coarse)').matches) return;
  let mx=-200,my=-200,rx=-200,ry=-200,started=false;
  document.addEventListener('mousemove',e=>{
    mx=e.clientX; my=e.clientY;
    if(!started){ started=true; document.body.classList.add('has-custom-cursor'); }
  });
  (function loop(){
    rx+=(mx-rx)*.1; ry+=(my-ry)*.1;
    dot.style.left=mx+'px'; dot.style.top=my+'px';
    ring.style.left=rx+'px'; ring.style.top=ry+'px';
    requestAnimationFrame(loop);
  })();
  qsa('a,button').forEach(el=>{
    el.addEventListener('mouseenter',()=>document.body.classList.add('cur-h'));
    el.addEventListener('mouseleave',()=>document.body.classList.remove('cur-h'));
  });
})();

/* ── SCROLL PROGRESS ── */
window.addEventListener('scroll',()=>{
  const p=window.scrollY/(document.documentElement.scrollHeight-window.innerHeight)*100;
  const bar=qs('#prog'); if(bar) bar.style.width=p+'%';
},{passive:true});

/* ── INTRO (homepage only) ── */
(()=>{
  const intro=qs('#intro'); if(!intro) return;
  setTimeout(()=>qsa('.intro-letter').forEach((l,i)=>setTimeout(()=>l.classList.add('in'),i*80)),200);
  setTimeout(()=>qs('#intro-sub')?.classList.add('in'),700);
  setTimeout(()=>{
    intro.classList.add('split');
    qsa('#hero-title .letter').forEach((l,i)=>setTimeout(()=>l.classList.add('in'),300+i*70));
    setTimeout(()=>qs('#hero-sub-row')?.classList.add('in'),900);
    setTimeout(()=>{
      qsa('.coll-card').forEach((c,i)=>setTimeout(()=>c.classList.add('on'),i*100));
      qsa('.prod-grid .pcard').forEach((c,i)=>setTimeout(()=>c.classList.add('on'),i*80));
    },1100);
  },1400);
  setTimeout(()=>intro.classList.add('gone'),2500);
})();

/* ── ABOUT ANIMS ── */
(()=>{
  const at1=qs('#at1'),at2=qs('#at2'); if(!at1) return;
  setTimeout(()=>at1.classList.add('in'),200);
  setTimeout(()=>at2.classList.add('in'),380);
})();

/* ── SCROLL REVEAL ── */
const io=new IntersectionObserver(entries=>{
  entries.forEach(e=>{
    if(!e.isIntersecting) return;
    const t=e.target;
    if(t.classList.contains('rv')||t.classList.contains('rv-l')||t.classList.contains('rv-s')) t.classList.add('on');
    if(t.classList.contains('pcard')) t.classList.add('on');
    if(t.classList.contains('coll-card')) t.classList.add('on');
    if(t.classList.contains('stat-box')){ t.classList.add('on'); countUp(t.querySelector('[data-target]')); }
    io.unobserve(t);
  });
},{threshold:.12});
qsa('.rv,.rv-l,.rv-s,.pcard,.coll-card,.stat-box').forEach(el=>io.observe(el));

/* ── COUNT UP ── */
function countUp(el){
  if(!el||!el.dataset.target) return;
  const target=+el.dataset.target; let cur=0;
  const step=Math.ceil(target/30);
  const t=setInterval(()=>{ cur=Math.min(cur+step,target); el.textContent=cur; if(cur>=target) clearInterval(t); },40);
}

/* ── MOBILE MENU ── */
function toggleMob(){qs('#mob-menu')?.classList.toggle('open');qs('#burger')?.classList.toggle('open');}
function closeMob(){qs('#mob-menu')?.classList.remove('open');qs('#burger')?.classList.remove('open');}
qs('#mob-menu')?.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMob));

/* ── CART DRAWER ── */
function openCart(){qs('#cart-drw')?.classList.add('on');qs('#cart-ov')?.classList.add('on');}
function closeCart(){qs('#cart-drw')?.classList.remove('on');qs('#cart-ov')?.classList.remove('on');}
qs('#cart-open')?.addEventListener('click',openCart);

/* ── POPUP ── */
function closePopup(){qs('#popup-ov')?.classList.remove('on');}
if(qs('#popup-ov')) setTimeout(()=>qs('#popup-ov').classList.add('on'),3000);

/* ── PRODUCT PAGE ── */
function swapImg(thumb, src){
  qsa('.pp-thumb').forEach(t=>t.classList.remove('on'));
  thumb.classList.add('on');
  const main=qs('#pp-main');
  if(main) main.src=src;
}
function selSz(btn){
  qsa('.sz').forEach(b=>b.classList.remove('on'));
  btn.classList.add('on');
  const inp=qs('#variant-id');
  if(inp) inp.value=btn.dataset.variantId||btn.dataset.variant_id||'';
}
function togAcc(trig){
  const exp=trig.getAttribute('aria-expanded')==='true';
  trig.setAttribute('aria-expanded',String(!exp));
  trig.nextElementSibling?.classList.toggle('open',!exp);
}

/* ── ATC FORM ── */
const atcForm=qs('#atc-form');
atcForm?.addEventListener('submit',e=>{
  e.preventDefault();
  const btn=qs('#atc-btn'); if(!btn) return;
  const id=qs('#variant-id')?.value;
  if(!id){ alert('Please select a size.'); return; }
  btn.disabled=true;
  btn.querySelector('span').textContent='Adding...';
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:parseInt(id),quantity:1})
  })
  .then(r=>{ if(!r.ok) throw new Error(r.status); return r.json(); })
  .then(()=>{
    btn.querySelector('span').textContent='Added!';
    fetchCart();
    setTimeout(()=>{ btn.disabled=false; btn.querySelector('span').textContent='Add to Cart'; openCart(); },600);
  })
  .catch(()=>{
    // Fallback: native form submit
    atcForm.submit();
  });
});

/* ── CART ── */
function fetchCart(){
  fetch('/cart.js').then(r=>r.json()).then(renderCart).catch(()=>{});
}

function renderCart(cart){
  qsa('.cart-count').forEach(el=>el.textContent=cart.item_count||0);
  const tot=qs('#cart-total-val');
  if(tot) tot.textContent='€'+(Number(cart.total_price||0)/100).toFixed(2).replace('.',',');
  const box=qs('#cart-items'); if(!box) return;
  if(!cart.items||cart.item_count===0){
    box.innerHTML='<p style="font-size:14px;font-weight:300;opacity:.5;padding:24px 0;">Your cart is empty.</p>';
    return;
  }
  box.innerHTML=cart.items.map(item=>{
    const varTitle=item.variant_title&&item.variant_title!=='Default Title'?`<p class="ci-var">${item.variant_title}</p>`:'';
    const img=item.image?`<img class="ci-img" src="${item.image}" alt="${item.product_title}">`:`<div class="ci-img" style="background:#f0ede8;"></div>`;
    return `<div class="ci-wrap">
      ${img}
      <div>
        <p class="ci-name">${item.product_title}</p>
        ${varTitle}
        <p class="ci-price">€${(Number(item.final_price||0)/100).toFixed(2).replace('.',',')}</p>
        <div class="ci-qty">
          <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity-1}">−</button>
          <span class="qty-n">${item.quantity}</span>
          <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity+1}">+</button>
        </div>
      </div>
      <button class="ci-del" data-key="${item.key}" data-qty="0">×</button>
    </div>`;
  }).join('');
  box.querySelectorAll('.qty-btn,.ci-del').forEach(btn=>{
    btn.addEventListener('click',()=>{
      btn.disabled=true;
      cartChange(btn.dataset.key, parseInt(btn.dataset.qty));
    });
  });
}

function cartChange(key, qty){
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key, quantity:qty})
  }).then(r=>r.json()).then(renderCart).catch(fetchCart);
}

document.addEventListener('DOMContentLoaded', fetchCart);

/* ── TILT CARDS ── */
qsa('.coll-card').forEach(card=>{
  card.addEventListener('mousemove',e=>{
    const r=card.getBoundingClientRect();
    const x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
    card.style.transform=`perspective(600px) rotateY(${x*10}deg) rotateX(${-y*8}deg) scale(1.02)`;
  });
  card.addEventListener('mouseleave',()=>card.style.transform='');
});

/* ── MAGNETIC BUTTONS ── */
qsa('.mani-cta,.pp-atc,.cf-submit,.checkout-btn').forEach(btn=>{
  btn.addEventListener('mousemove',e=>{
    const r=btn.getBoundingClientRect();
    const x=(e.clientX-r.left-r.width/2)*.25, y=(e.clientY-r.top-r.height/2)*.25;
    btn.style.transform=`translate(${x}px,${y}px)`;
  });
  btn.addEventListener('mouseleave',()=>btn.style.transform='');
});

/* ── FILTER BUTTONS ── */
qsa('.filter-btn').forEach(btn=>{
  btn.addEventListener('click',()=>{
    qsa('.filter-btn').forEach(b=>b.classList.remove('on'));
    btn.classList.add('on');
  });
});
